// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_de-2";
export var aiChatCartContainerExit = "_de-4";
export var aiChatContainerLarge = "_de-0";
export var aiChatContainerSmall = "_de-1";
export var aiChatIcon = "_de-6";
export var slideInFromRight = "_de-3";
export var slideOutToRight = "_de-5";